import { CampaignTemplate } from "./appt.model";
import { Contact } from "./contact.model";
import { EmailTemplate } from "./emailTemplate.model";
import { SimpleResponse, UserDD } from "./genericResponse.model";
import { EngageImageDocument } from "./imageDocument.model";
import { MailingContact } from "./mailingContact.model";
import { keyValue, SearchQueryResponse } from "./search.model";
import { TxtMsgTemplate } from "./textMsgTemplate.model";

export interface TxtMsg {
    txtMsgID: number;
    cLPCompanyID: number;
    cLPUserID: number;
    contactID: number;
    countryCode: string;
    mobileNumber: string;
    msg: string;
    status: number;
    requestID: string;
    requestComment: string;
    campaignID: number;
    campaignEventID: number;
    runID: number;
    cLPServiceRunID: number;
    dtSend: string;
    strDtsend: string;
    dtCreated: Date;
    isToUser: boolean;
    isUseShortCode: boolean;
    mediaURL: string;
    isThrottle: boolean;
    toCLPUserID: number;
    imgID: number;
    isScheduled: boolean;
    txtMsgLongCode: string;
    bWMessageId: string;
    dtSentFromBW: Date;
    dtSentToBW: Date;
    fromNumber: string;
    isUseTollFree: boolean;
}

export interface TxtMsgBulk {
    txtMsgID: number;
    cLPCompanyID: number;
    cLPUserID: number;
    contactID: number;
    countryCode: string;
    mobileNumber: string;
    msg: string;
    status: number;
    requestID: string;
    requestComment: string;
    campaignID: number;
    campaignEventID: number;
    runID: number;
    cLPServiceRunID: number;
    dtSend: string;
    isToUser: boolean;
    isUseShortCode: boolean;
    mediaURL: string;
    isThrottle: boolean;
    toCLPUserID: number;
    txtMsgLongCode: string;
    timeZoneWinId: number;
    standardName: string;
    fromNumber: string;
    isUseTollFree: boolean;
}

export interface TxtMsgResponse extends SimpleResponse {
    txtMsg: TxtMsg;
}


export interface TxtMsgSettingLoadResponse extends SimpleResponse {
    txtMsgSettings: TxtMsgSettings;
}
export interface TxtMsgSettings extends SimpleResponse {
    cLPCompanyID: number;
    cLPUserID: number;
    aPIKey: string;
    optInKeyword: string;
    status: number;
    isAllowFreeForm: boolean;
    isShowContactIcon: boolean;
    isEnableTxtBlast: boolean;
    optInEmailTemplateID: number;
    dtCreated: Date;
    tollFreeLongCode: string;
    bWAPIVersion: number;
    voiceAPIKey: string;
    orgName: string;
    supportNumber: string;
    linkTC: string;
    isEnableVoiceDropCampaign: boolean;
    isAllowVerbalOptinOption: boolean;
    optinAPID: number;
    sMSOptinRequest: string;
    sMSOptinResponse: string;
    sMSOptoutResponse: string;
    sMSPromoComplianceApend: string;
    isAllowVerbalPromoOptinOption: boolean;
    sMSInfoComplianceApend: string;
}

export interface TxtMsgSettingsResponse extends SimpleResponse {
    txtMsgSettings: TxtMsgSettings;
    emailTemplates: EmailTemplate[];
    filterUser: keyValue[];
    isShowRequestActivation: boolean;
    isShowAdminSettings: boolean;
    isShowOptinEmailTemplate: boolean;
    optInAutomationProcessDD: CampaignTemplate[];
}
export interface Status {
    value: Number;
    name: String;
}

export interface ScheduleMailingTxtMsg {
    contactList: Contact[];
    txtMsgBulkObj: TxtMsgBulk;
}

export interface MailingTxtMsgSaveRequest {
    contactList: MailingContact[];
    mailingClpUserId: number;
    clpCompanyId: number;
    clpUserId: number;
    slurrpyUserId: number;
    schedulingDate: string;
    isOverride: boolean;
    isPromo: boolean;
    isSlurrpy: boolean;
    fromNumber: string;
    fromType: number;
    message: string;
    mediaUrl: string;
    processAll: boolean;
    customSearchID: number;
    searchQueryResponse: SearchQueryResponse;
}

export interface TxtMsgKeywordResponse extends SimpleResponse {
    txtMsgKeywordList: TxtMsgKeyword[];
}

export interface TxtMsgKeyword {
    txtMsgKeywordID: number;
    keyword: string
    cLPCompanyID: number;
    cLPUserID: number;
    defaultCLPUserID: number;
    cTAction: number;
    cTCampaignTemplateID: number;
    cTCLPUserID: number;
    score: number;
    status: number;
    isPrimary: boolean;
    responseMsg: string;
    dtCreated: Date;
    roundRobinID: number;
    updateContactField: number;
}

export interface TxtMsgMailingFilterResponse extends SimpleResponse {
    isShowBizDayOverride: boolean;
    isShowCampaignOwnerDD: boolean;
    isShowFromUserDD: boolean;
    isShowTemplateDD: boolean;
    isShowMediaImagesDD: boolean;
    isShowMessageTxt: boolean;
    strCampaignOwner: string;
    isSlurrpy: boolean;
    isAllowFreeForm: boolean;
    ddCLPUser: UserDD[];
    txtMsgSettings: TxtMsgSettings;
    txtMsgTemplate: TxtMsgTemplate[];
    mediaImages: EngageImageDocument[];
}

export interface MobileBlockLog {
    mobileBlockLogID: number;
    cLPCompanyID: number;
    mobile: string;
    type: number;
    typeDisplay: string;
    notes: string;
    dtCreated: string;
}

export interface MobileBlockLogListResponse extends SimpleResponse {
    mobileBlockLogList: MobileBlockLog[];
}

export interface MobileOptLog {
    mobileOptLogID: number;
    cLPCompanyID: number;
    mobile: string;
    type: number;
    notes: string;
    typeDisplay: string;
    dtCreated: string;
}

export interface MobilePromoOptLog {
    mobilePromoOptLogID: number;
    cLPCompanyID: number;
    mobile: string;
    type: number;
    typeDisplay: string;
    notes: string;
    dtCreated: string;
}

export interface MobileOptLogListResponse extends SimpleResponse {
    mobileOptLogList: MobileOptLog[];
}

export interface MobilePromoOptLogListResponse extends SimpleResponse {
    mobilePromoOptLogList: MobilePromoOptLog[];
}

export interface TxtMsgPhRequest {
    contactID: number;
    cLPUserID: number;
    txtMsgTemplateID: number;
    strMsg: string;
    strMediaURL: string;
}

export interface MobileBlockOptLogListResponse extends SimpleResponse {
    mobilePromoOptLogList: MobileBlockOptLog[];
}

export interface MobileBlockOptLog {
    catDisplay: string;
    typeDisplay: string;
    notes: string;
    dtCreated: string;
}
